import { useAuthState } from '../useAuthState'

/** Returns whether or not the current user is the billing admin of a self-service
 * org, as of right now those are  Pro+ and/or ProFlex orgs */
export const useIsSelfServiceBillingAdmin = (): boolean => {
  const authState = useAuthState()
  const isSelfServiceBillingAdmin = authState.jwt?.org?.userOrgRoleExtras?.includes(
    'org_role_extra:billing_admin'
  )

  return Boolean(isSelfServiceBillingAdmin)
}
